import { doc, collection, setDoc, query, where, getDocs, updateDoc, deleteDoc } from "firebase/firestore";
import { db } from "..";

// Add a new document in collection "comments"
const addRating = async (_score, _userId, _whiskeyId, _type) => {
    const q = query(collection(db, "rating"), where("userId", "==", _userId), where("type", "==", _type), where("whiskeyId", "==", _whiskeyId))
    const querySnapshot = await getDocs(q)
    if (querySnapshot.docs.length > 0) {
        const updateRef = doc(db, "rating", querySnapshot.docs[0].id)
        if (_score === querySnapshot.docs[0].data().score && _type === querySnapshot.docs[0].data().type) {
            await deleteDoc(doc(db, "rating", querySnapshot.docs[0].id))
        }
        else {
            await updateDoc(updateRef, {
                score: _score
            })
        }
    }
    else {

        const ratingRef = doc(collection(db, "rating"))
        const data = {
            score: _score,
            userId: _userId,
            whiskeyId: _whiskeyId,
            created: Date.now(),
            type: _type
        }
        await setDoc(ratingRef, data);
    }
console.log("done db")
}

export default addRating